import { render, staticRenderFns } from "./FullContainer.vue?vue&type=template&id=590674c1&scoped=true&"
import script from "./FullContainer.vue?vue&type=script&lang=js&"
export * from "./FullContainer.vue?vue&type=script&lang=js&"
import style0 from "./FullContainer.vue?vue&type=style&index=0&id=590674c1&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590674c1",
  null
  
)

export default component.exports